<template>

    <v-container fill-height fluid grid-list-xl>
        <v-layout justify-center wrap>
            <v-flex xs12 md12>
                <material-card
                        class="card-tabs"
                        color="green">
                    <v-flex slot="header">
                        Results summary
                    </v-flex>

                    <v-flex row>
                        <div  class="date-range col-md-6">
                            <label for="picker">Select Dates:</label>
                            <date-range-picker
                                    id="picker"
                                    ref="picker"
                                    class="col-md-6"
                                    :opens="opens"
                                    :singleDatePicker="singleDatePicker"
                                    :timePicker="false"
                                    :showWeekNumbers="false"
                                    :showDropdowns="false"
                                    :autoApply="autoApply"
                                    v-model="dateRange"

                                    :linkedCalendars="linkedCalendars"
                                    :dateFormat="dateFormat"
                            >
                                <template v-slot:input="picker" style="min-width: 350px;">
                                    {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                                </template>
                            </date-range-picker>
                        </div>
                        <div class="col-md-6 row">
                            <label for="" class="mr-3 mt-2" >Chart Type:</label>
                            <select name="" v-model="currentChart" id="" class="form-control col-md-6">
                                <option value="#">Select a chart type</option>
                                <option value="bar">Bar Chart</option>
                                <option value="area">Area Chart</option>
                            </select>
                        </div>



                    </v-flex>
                    <v-flex>
                        <div class="small">
                            <AreaChart v-if="loaded && currentChart == 'area'" :options="options" :width="400" :height="400" :chart-data="datacollection"></AreaChart>
                            <barchart v-if="loaded && currentChart == 'bar'" :options="options" :width="400" :height="400" :chart-data="datacollection"></barchart>

                        </div>

                    </v-flex>
                </material-card>
                <v-dialog
                        v-model="progressDialog"
                        hide-overlay
                        persistent
                        width="300"
                >
                    <v-card
                            color="primary"
                            dark
                    >
                        <v-card-text>
                            Loading Data
                            <v-progress-linear
                                    indeterminate
                                    color="white"
                                    class="mb-0"
                            ></v-progress-linear>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import AreaChart from "../plugins/AreaChart";
    import barchart from "../plugins/barchart";
    import {getAreaChartData} from "../api/routes";
    import DateRangePicker from 'vue2-daterange-picker'
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
    import moment from 'moment'
    export default {
        name: "Chart",
        components: {
            AreaChart,
            barchart,
            DateRangePicker
        },
        data() {
            return {
                opens: "right",
                minDate: null,
                currentChart: 'area',
                maxDate: null,
                singleDatePicker: null,
                timePicker: null,
                timePicker24Hour: null,
                linkedCalendars: null,
                dateFormat: null,
                showWeekNumbers: null,
                showDropdowns: null,
                autoApply: true,
                dateRange: {
                    startDate: new Date(moment().startOf('year')),
                    endDate:    new Date()
                },
                datacollection: null,
                options: null,
                loaded: false,
                progressDialog: true,
                date: null,
            }
        },
        mounted() {
            this.options = {
                responsive: true,
                maintainAspectRatio: false,
                legends: {
                  display: true,
                  position: 'bottom'
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        },
                        stacked: false
                    }],
                    xAxes: [
                        {
                            stacked: false
                        }
                    ]
                },

            };

            this.getDashboardData()

        },
        watch: {
          dateRange: 'getDashboardData'
        },
        filters: {
            formatDate: function (date) {
                return moment(date).format("MM-DD-YYYY")
            },
        },
        methods: {

             getRandomColor() {
                var letters = '0123456789ABCDEF';
                var color = '#';
                for (var i = 0; i < 6; i++) {
                    color += letters[Math.floor(Math.random() * 16)];
                }
                return color;
            },
            getRandomInt () {
                return Math.floor(Math.random() * (50 - 5 + 1)) + 5
            },
            getDashboardData(){
                this.progressDialog = true;

                let postData = {
                    'startDate' :   moment(this.dateRange.startDate).format('YYYY-MM-DD'),
                    'endDate'   :   moment(this.dateRange.endDate).format('YYYY-MM-DD')
                };
                getAreaChartData(postData)
                    .then(resp => resp.data)
                    .then(resp => {
                    console.log(resp);
                    this.datacollection = {
                        labels:  resp.labels,
                        datasets: [

                        ]
                    };
                    let data = resp.data;
                    for (let i = 0; i < data.length; i++) {
                        let set = {
                            label: data[i].label,
                            backgroundColor: this.getRandomColor(),
                            data: data[i].count,
                            borderWidth: 1,
                            fill: true,
                        };
                        this.datacollection.datasets.push(set);

                    }


                }).catch(error => {
                    console.log('error', error)
                }).finally(final => {
                    this.loaded = true;
                    this.progressDialog = false;
                })
            },

        }
    }
</script>
<style>
    .small {
        max-width: 600px;
        height: 400px;
    }
    .date-range {
        max-width: 600px;
        height: 40px;
    }

</style>
